/**
 *   Generated file. Do not edit
 */

import { WifiMode } from './models';
import { WifiProtocol } from './models';
import { WifiSSIDVisibility } from './models';
import { WifiKeyVisibility } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {}
  export interface TapStreamWriter {}
}
